import { IAutocompleteMatch } from "@directives/_forms/autocomplete/autocomplete.component";
import { ExternalReferenceService } from "@directives/_veri/externalReference/externalReference.service";
import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "@directives/_veri/veriTable/veriTable.component";
import { VeriTableService } from "@directives/_veri/veriTable/veriTable.service";
import { SortType } from "@enums/SortType";
import { VehicleType } from "@enums/VehicleType.enum";
import { IGeofence } from "@interfaces/IGeofences";
import { IKeyValuePair } from "@interfaces/IKeyValuePair";
import { IProbe } from "@interfaces/IProbe";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { IUser } from "@interfaces/IUser";
import { IVehicle } from "@interfaces/IVehicle";
import { AccountOption } from "@services/class/AccountOption";
import { DriverAssignmentService } from "@services/driverAssignment.service";
import { EnumService } from "@services/enum.service";
import { GeofenceService } from "@services/geofence.service";
import { GroupService } from "@services/group.service.ajs";
import { MessageDialogService } from "@services/messageDialog.service";
import { ReasonCodeService } from "@services/reasonCode.service";
import { SessionService } from "@services/session.service";
import { TranslationService } from "@services/translation.service";
import { UnitConversionService, UnitConversionType } from "@services/unitConversion.service";
import { VehicleService } from "@services/vehicle.service";
import { VehicleInputService } from "@services/vehicleInput.service";
import { VeriDate } from "@services/veriDate.service";
import { StateService } from "@uirouter/angularjs";
import * as angular from "angular";
import copy from "fast-copy/dist/fast-copy.esm.js";
import * as moment from "moment";
import { SettingsName } from "../../../../class/SettingsName";
import { DataValidationStatus } from "../../fleetMaintenance/IVehicleData";
import { VehicleDataService } from "../../fleetMaintenance/vehicleData.service";
import { IGroupWithIds } from "../groups/_models/IGroupWithIds";
import { IVorRecord } from "../vor/vor.interfaces";
import "./vehicles.scss";

interface IVehiclesBindings {
    onVehiclesChanged: Function
}

export class VehiclesComponentController implements IVehiclesBindings, angular.IComponentController {
    loading: boolean;
    saving: boolean;

    onVehiclesChanged: Function;

    vehicles: IVehicle[];
    selectedVehicle: IVehicle;

    groups: IGroupWithIds[];
    depots: IGroupWithIds[];

    selectedGeofence: IGeofence;
    geofences: IGeofence[];

    vehicleTypes: IKeyValuePair[];

    currentUser: IUser;

    vehicleDepotId: number;
    previousVehicleDepotId: number;

    canEditOdometer: boolean;
    odometer: string;

    tableHeaders: IVeriTableHeader[] = [];
    tableRows: IVeriTableRow<IVehicle>[] = [];

    inputsValid = true;

    inputErrorMessage: string;
    probesTabDisabled: boolean;

    static $inject = ["$state", "$rootScope", "$q", "vehicleService", "groupService", "messageDialogService", "vehicleDataService", "sessionService", "vehicleInputService", "driverAssignmentService", "veriDate", "$mdDialog", "unitConversionService", "externalReferenceService", "geofenceService", "veriTableService", "translationService", "reasonCodeService"];

    constructor(
        private readonly $state: StateService,
        private readonly $rootScope: IRunBlockRootScope,
        private readonly $q: angular.IQService,
        private readonly vehicleService: VehicleService,
        private readonly groupService: GroupService,
        private readonly messageDialogService: MessageDialogService,
        private readonly vehicleDataService: VehicleDataService,
        private readonly sessionService: SessionService,
        private readonly vehicleInputService: VehicleInputService,
        private readonly driverAssignmentService: DriverAssignmentService,
        private readonly veriDateService: VeriDate,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly unitConversionService: UnitConversionService,
        private readonly externalReferenceService: ExternalReferenceService,
        private readonly geofenceService: GeofenceService,
        private readonly veriTableService: VeriTableService,
        private readonly translationService: TranslationService,
        private readonly reasonCodeService: ReasonCodeService
    ) {
    }

    $onInit(): void {

        this.getAccountOptions();
        this.currentUser = copy(this.$rootScope.currentUser);

        this.setVehicleTypes();

        this.loadData(true).then(() => {
            const model = this.$state.params['model'];

            if (model) {
                const modelId = model["Id"] || model;
                const foundVehicle = this.vehicles.find(v => v.Id == modelId);

                if (foundVehicle) {
                    this.selectVehicle(foundVehicle);
                }
            }
        });

        this.createTableHeaders();
    }

    cancelVehicleChanges() {
        this.selectedVehicle = null;
    }

    checkInputValidity(message: string) {
        this.inputErrorMessage = '';
        this.inputErrorMessage = message;
    }

    onDepotClicked(match: IAutocompleteMatch, event: MouseEvent) {
        if (!match) {
            this.vehicleDepotId = null;

            if (!this.selectedVehicle.GeofenceId) {
                this.selectedGeofence = null;
            }
        }
        else {
            this.previousVehicleDepotId = this.vehicleDepotId;
            this.vehicleDepotId = match.objectId;

            if (!this.selectedVehicle.GeofenceId) {
                this.setSelectedGeofence(this.vehicleDepotId);
            }
        }

    }

    onVorUpdate(vorRecord: IVorRecord) {
        this.selectedVehicle.vorRecord = vorRecord;
        this.createTableRows();
    }

    openOdometerEdit(event: MouseEvent) {
        const dialogOptions: angular.material.IDialogOptions = {
            template: require("../../livemap/components/editOdometer.template.html"),
            targetEvent: event,
            escapeToClose: true,
            clickOutsideToClose: true,
            controller: "editOdometerController",
            controllerAs: "$ctrl",
            locals: {
                selectedVehicle: this.selectedVehicle
            }
        };

        this.$mdDialog.show(dialogOptions);
    }

    saveVehicleChanges() {
        this.saving = true;

        if (this.selectedVehicle.Driver) {
            this.selectedVehicle.Driver.vehicle = null;
        }

        if (!this.selectedVehicle.PhoneNumber) {
            this.selectedVehicle.PhoneNumber = "";
        }

        var promises: angular.IPromise<any>[] = [];

        const vehicleSavingPromise = this.vehicleService.updateVehicle(this.selectedVehicle, true);

        promises.push(vehicleSavingPromise);

        this.selectedVehicle.probes.forEach(probe => {
            probe.PrimaryNotification = "";

            probe.notificationList.forEach(notification => {
                if (notification.notification === "") {
                    return;
                }

                probe.PrimaryNotification += notification.notification + ";";
            });

            probe.SecondaryNotification = "";

            probe.secondNotificationList.forEach(notification => {
                if (notification.notification === "") {
                    return;
                }

                probe.SecondaryNotification += notification.notification + ";";
            });

            promises.push(this.vehicleService.updateVehicleProbe(probe, true));
        });

        const inputSavingPromise = this.vehicleInputService.saveInputs(this.selectedVehicle.Id, this.selectedVehicle.Inputs);
        promises.push(inputSavingPromise);

        if (this.vehicleDepotId && this.previousVehicleDepotId !== this.vehicleDepotId) {
            const groupSavingPromise = this.vehicleService.updateDepot(this.selectedVehicle.Id, this.vehicleDepotId);
            promises.push(groupSavingPromise);
        }

        this.$q.all(promises)
            .then(() => {
                this.vehicleService.getVehicleProbes(this.selectedVehicle);

                this.selectedVehicle = null;
                this.loadData(true);
            })
            .catch(err => {
                this.messageDialogService.handleError(err, this.translationService.t("resourceManagementVehicles.UnableToSave"))
            })
            .finally(() => {
                this.saving = false;
            });
    }

    selectVehicle(vehicle: IVehicle) {
        this.inputErrorMessage = null;

        this.selectedVehicle = copy(vehicle);
        if (this.selectedVehicle?.Plot) {
            const odometerKm = Math.round(this.selectedVehicle.Plot.Odometer / 1000);
            this.odometer = this.unitConversionService.convertUnitWithSuffix(odometerKm, UnitConversionType.Distance);
        }
        else {
            this.odometer = "";
        }

        this.updateVehicleGroupIds()

        const vehicleDepot = this.depots.find(x => x.VehicleIds.includes(vehicle.Id));
        this.vehicleDepotId = vehicleDepot?.Id;

        // Always get new sets of probes
        this.selectedVehicle.probes = [];
        this.vehicleService
            .getVehicleProbes(vehicle, true)
            .then(probes => {
                this.probesTabDisabled = probes.length === 0;
                this.selectedVehicle.probes = probes;
                this.setProbeClientSideValues(this.selectedVehicle.probes);
            });

        this.vehicleInputService.getVehicleInputs(this.selectedVehicle.Id).then(inputs => {
            this.selectedVehicle.Inputs = inputs;
        });

        if (this.selectedVehicle.GeofenceId) {
            this.setSelectedGeofence(this.selectedVehicle.GeofenceId);
        }
        else {
            this.selectedVehicle.GeofenceId = null;
            this.setSelectedGeofence(this.vehicleDepotId);
        }
    }

    selectedGeofenceChange(match: IAutocompleteMatch) {
        if (!match) {
            if (this.vehicleDepotId) {
                this.setSelectedGeofence(this.vehicleDepotId);
            }
            else {
                this.selectedGeofence = null;
            }

            this.selectedVehicle.GeofenceId = null;
            return;
        }

        this.selectedVehicle.GeofenceId = match.objectId;
        this.setSelectedGeofence(match.objectId);
    }

    setProbeClientSideValues(probes: IProbe[]) {
        probes.forEach(probe => {
            probe.notificationList = [];
            probe.secondNotificationList = [];

            if (probe.PrimaryNotification !== "") {
                probe.PrimaryNotification.split(";").forEach(value => {
                    if (value === "") {
                        return;
                    }

                    probe.notificationList.push({ notification: value });
                });
            }

            probe.notificationList.push({ notification: "" });

            if (probe.SecondaryNotification !== "") {
                probe.SecondaryNotification.split(";").forEach(value => {
                    if (value === "") {
                        return;
                    }

                    probe.secondNotificationList.push({ notification: value });
                });
            }
            probe.secondNotificationList.push({ notification: "" });

            if (probe.PrimaryRollingAverageMins > 0) {
                probe.useRollingAverage = true;
            }
            if (probe.SecondaryRollingAverageMins > 0) {
                probe.useSecondRollingAverage = true;
            }
        });
    }

    // ----------------------------------------------------------------------------

    private updateVehicleGroupIds() {
        this.selectedVehicle.GroupIds = [];

        this.groupService.addGroupsIdsToVehicles([this.selectedVehicle], this.groups);
    }

    private createTableHeaders() {
        this.tableHeaders = [
            { title: this.translationService.t("Common.Status"), sortable: true, width: 120 },
            this.veriTableService.createVehicleRegHeader(),
            { title: this.translationService.t("Common.Driver"), sortable: true },
            { title: this.translationService.t("Common.Type"), sortable: true, width: 120 },
            { title: this.translationService.t("resourceManagementVehicles.Year"), sortable: true, width: 60 },
            { title: this.translationService.t("resourceManagementVehicles.MakeModel"), sortable: true, width: 150 },
            { title: this.translationService.t("Common.Odometer"), sortable: true, width: 120, sortType: SortType.Number },
            { title: this.translationService.t("resourceManagementVehicles.mot"), width: 60, sortable: true, sortType: SortType.Date },
            { title: this.translationService.t("resourceManagementVehicles.tax"), width: 60, sortable: true, sortType: SortType.Date },
            { title: this.translationService.t("Common.Depot"), sortable: true },
            { title: this.translationService.t("Common.Groups"), excludeFromExport: true },
            { title: this.translationService.t("resourceManagementVehicles.externalReference"), hide: true, sortable: true }
        ];
    }

    private createTableRows() {
        this.tableRows = [];

        if (this.vehicles) {
            this.vehicles.forEach(vehicle => {
                const row = this.createTableRow(vehicle);
                this.tableRows.push(row);
            });
        }
    }

    private createTableRow(vehicle: IVehicle) {
        const row: IVeriTableRow<IVehicle> = {
            cells: this.createTableRowCells(vehicle),
            data: vehicle,
            //dropDownFilterValues: this.groupService.findGroupIdsAssetBelongsTo(this.groups, vehicle.Id, "VehicleIds")
        };

        return row;
    }

    private createTableRowCells(vehicle: IVehicle): IVeriTableRowCell[] {
        let motExportData = "";
        let motContents = "";

        if (this.isEligibleForDVLACheck(vehicle) && vehicle.vehicleData && vehicle.vehicleData.motExpirationStatus !== DataValidationStatus.NoDetailsFound) {
            var iconClass = "not-due";
            var icon = "done";

            if (vehicle.vehicleData.motExpirationStatus == DataValidationStatus.DueSoon) { iconClass = "due"; icon = "warning"; }
            else if (vehicle.vehicleData.motExpirationStatus == DataValidationStatus.Expired) { iconClass = "expired"; icon = "warning"; }

            motExportData = `Due ${this.veriDateService.formatDate(vehicle.vehicleData.MotExpiry, "date")}`;
            motContents = `<span title="${motExportData}"><i class="material-icons s16 ${iconClass}">${icon}</i></span>`;
        }

        let taxExportData = "";
        let taxContents = "";

        if (this.isEligibleForDVLACheck(vehicle) && vehicle.vehicleData && vehicle.vehicleData.taxExpirationStatus !== DataValidationStatus.NoDetailsFound) {
            var iconClass = "not-due";
            var icon = "done";

            if (vehicle.vehicleData.taxExpirationStatus == DataValidationStatus.DueSoon) { iconClass = "due"; icon = "warning"; }
            else if (vehicle.vehicleData.taxExpirationStatus == DataValidationStatus.Expired) { iconClass = "expired"; icon = "warning"; }

            taxExportData = `Due ${this.veriDateService.formatDate(vehicle.vehicleData.TaxExpiry, "date")}`;
            taxContents = `<span title="${taxExportData}"><i class="material-icons s16 ${iconClass}">${icon}</i></span>`;
        }

        const depot = this.depots.find(x => x.VehicleIds.includes(vehicle.Id));

        return [
            this.veriTableService.createVehicleStatusCell(vehicle),
            this.veriTableService.createVehicleRegCell(vehicle),
            { contents: vehicle.Driver && vehicle.Driver.Name || "" },
            { contents: this.translationService.tEnum(VehicleType, "VehicleType", vehicle.VehicleType) },
            vehicle.vehicleData?.VehicleYear
                ? { contents: vehicle.vehicleData.VehicleYear }
                : this.veriTableService.createNACell(),
            vehicle.vehicleData?.DvlaMake
                ? this.veriTableService.createStackedCell(vehicle.vehicleData.DvlaMake, vehicle.vehicleData.DvlaModel)
                : this.veriTableService.createNACell(),
            vehicle.Plot
                ? { contents: this.unitConversionService.convertUnitWithSuffix(vehicle.Plot.Odometer / 1000, UnitConversionType.Distance, 0), sortData: vehicle.Plot.Odometer }
                : this.veriTableService.createNACell(),
            { contents: motContents, sortData: vehicle.vehicleData && vehicle.vehicleData.MotExpiry || "2000-01-01T00:00", exportData: motExportData },
            { contents: taxContents, sortData: vehicle.vehicleData && vehicle.vehicleData.TaxExpiry || "2000-01-01T00:00", exportData: taxExportData },
            {
                contents: depot ? `<depot-name [name]="cell.data.Name"></depot-name>` : "",
                exportData: depot?.Name,
                data: depot,
                sortData: depot?.Name
            },
            this.veriTableService.createVehicleResourceGroupDisplayCell(vehicle, this.groups),
            { contents: vehicle.externalReferences ? vehicle.externalReferences.map(m => m.ExternalReference).join() : "" }
        ];
    }

    private getAccountOptions() {
        const accountOptions = this.sessionService.getItem<AccountOption>(SettingsName.AccountOptions);

        if (accountOptions) {
            this.canEditOdometer = accountOptions.EditOdometer;
        }
    }

    private loadData(invalidateCache = false) {
        this.loading = true;

        const vehiclesPromise = this.driverAssignmentService.getVehiclesWithDrivers({
            includeTags: true,
            includeVOR: true,
            includeProbes: true,
            includeTrailerMappings: true,
            includeLatestPlots: true,
            includePeripheralMappings: true,
            invalidateCache
        });

        const groupPromise = this.groupService.getGroupsWithFullMappings(invalidateCache);
        const vehicleDataPromise = this.vehicleDataService.getVehicleData();
        const externalReferencesPromise = this.externalReferenceService.getAllVehicleExternalReferences(invalidateCache);
        const geofencesPromise = this.geofenceService.getGeofences();

        return this.$q.all([vehiclesPromise, groupPromise, vehicleDataPromise, externalReferencesPromise, geofencesPromise])
            .then(([vehicles, groups, vehicleDataList, externalReferenceList, geofences]) => {
                this.vehicles = vehicles;
                this.groups = groups;
                this.geofences = geofences;

                this.depots = groups.filter(group => group.IsDepot);

                this.vehicles.forEach(vehicle => {
                    vehicle.externalReferences = externalReferenceList.filter(ref => ref.VehicleId === vehicle.Id);

                    var vehicleData = this.vehicleDataService.findVehicleData(vehicle.Id, vehicleDataList);
                    if (!vehicleData) {
                        return;
                    }

                    this.vehicleDataService.calculateMOTAndTaxStatus(vehicle, vehicleData);

                });

            })
            .finally(() => {
                this.createTableRows();
                this.loading = false;
            });
    }

    private setVehicleTypes() {
        this.vehicleTypes = EnumService.getItemsForSelect(VehicleType);

        this.vehicleTypes.forEach(type => {
            type.displayName = this.translationService.translateEnum(VehicleType, "VehicleType", type.value as any);
        });
    }

    private isEligibleForDVLACheck(vehicle: IVehicle): boolean {

        return vehicle.VehicleType != VehicleType.Trailer && (vehicle.HasUnit || vehicle.hasCamera) && vehicle.Plot?.UtcMoment.isSameOrAfter(moment().add(-2, "days"))

    }

    private setSelectedGeofence(Id: number) {
        this.selectedGeofence = null;

        const foundGeofence = this.geofences.find(g => g.Id === Id);
        var foundGroup = this.groups.find(g => g.Id === Id);

        if (foundGeofence) {
            this.selectedGeofence = foundGeofence;
        }

        if (foundGroup) {
            this.geofences.forEach(g => {
                if (g.Id == foundGroup.GeofenceId) {
                    this.selectedGeofence = g;
                }
            });
        }
    }
}

export class VehiclesComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            onVehiclesChanged: "&"
        };

        this.controller = VehiclesComponentController;
        this.template = require(`./vehicles.html`);
    }
}
